module.exports = __webpack_public_path__ + "static/media/blue-mountains.6c586442.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/blue-mountains.jpg
// module id = 130
// module chunks = 0